import axios from "../../axiosMiddleware";
import { api } from "../../apiendpoints";

export const GetMissingPunches = async () => {
  return axios.post(
    api.TIME_ATTENDANCE.GET_MISSING_PUNCHES,
    {}
  );
};

export const AddMissingPunch = async (payload) => {
  if (!payload) {
    throw new Error(
      "Missing punch payload is required."
    );
  }

  return axios.post(
    api.TIME_ATTENDANCE.ADD_MISSING_PUNCH,
    payload
  );
};
